module.exports = __webpack_public_path__ + "static/media/icon-back-blue.55997cc9.svg";